module.exports = __webpack_public_path__ + "img/santaritapassa.48139046.png";